import { ENVIRONMENT } from "src/js/util/environment";
import { Intercom } from "src/js/util/intercom";
import { ModalV2 } from "react-migration/components/ModalV2/ModalV2";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Button } from "react-migration/components/Button";

export const LicenseBlockModal = () => {
  const { t } = useTranslation();

  return (
    <ModalV2.Root defaultOpen={true}>
      <ModalV2.Body title={t("nav.license_block_modal.title")} className="z-1000!" hideClose={true} disableClose={true}>
        <div className="text-sm leading-normal text-neutral-800" data-testid="kicked-modal">
          <p>{t("nav.license_block_modal.message")}</p>
        </div>
        <div className="flex justify-end gap-2 pt-4">
          <Button variant="secondary" onClick={() => Intercom("show")}>
            {t("nav.license_block_modal.action.demo")}
          </Button>
          <Button
            onClick={() =>
              (window.location.href = `${ENVIRONMENT.ACCOUNTS_SERVICE_PRIVATE_API_URL}/customer-portal?flow=upgrade`)
            }
          >
            {t("nav.license_block_modal.action.upgrade")}
          </Button>
        </div>
      </ModalV2.Body>
    </ModalV2.Root>
  );
};
